import api from "@/lib/api";

// Anonymous, PII-free demo engagement tracking. Failures are silently ignored.
export function demoSid() {
  let s = sessionStorage.getItem("cr_demo_sid");
  if (!s) {
    s = Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem("cr_demo_sid", s);
  }
  return s;
}

export function trackDemo(event, data = {}) {
  api.post("/demo/track", { event, session_id: demoSid(), ...data }).catch(() => {});
}
